<mat-paginator
        [length]="itemCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEventHandler($event)">
</mat-paginator>
